console.log("router-cache-bust.js loaded");
(function () {
    // Homepage cache may be reused this long after prefetch/navigate (keeps logo fast).
    var HOME_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

    // How long a tab must stay hidden before we clear the full SPA cache.
    var HIDDEN_MS = 24 * 60 * 60 * 1000; // 24 hours

    // Do not hit the network for a build check more often than this.
    var BUILD_CHECK_MIN_MS = 10 * 1000; // 10 seconds

    // Wait this long after navigation before build-check fetch (avoids competing
    // with the real Highway page request, e.g. going Home via #main-logo).
    var BUILD_CHECK_DELAY_MS = 750;

    // Periodic safety net: re-check the build every few minutes even if the
    // user never navigates, so idle-but-visible tabs pick up promo changes
    // (pencil bar) without any user action. Skipped while the tab is hidden.
    var PERIODIC_CHECK_MS = 5 * 60 * 1000; // 5 minutes
    var BUILD_CHECK_TIMEOUT_MS = 10 * 1000;
    var RELOAD_GUARD_MS = 60 * 1000;

    var hiddenAt = null;
    var hooked = false;
    var buildChecking = false;
    var lastBuildCheck = 0;
    var buildCheckTimer = null;
    var retryTimer = null;
    var failures = 0;
    var reloadRequested = false;
    var freshnessState = window.__OZ_FRESHNESS_STATE__ = { status: "starting", failureCount: 0 };

    // url string -> timestamp when that homepage entry was stored in router.cache
    var homeCachedAt = {};

    // ---------------------------------------------------------------------------
    // isHomeUrl(url)
    // True for the site homepage (/, optional trailing slash / query).
    // ---------------------------------------------------------------------------
    function isHomeUrl(url) {
        if (!url) return false;

        try {
            var u = new URL(url, window.location.origin);
            if (u.origin !== window.location.origin) return false;
            var path = u.pathname.replace(/\/+$/, "") || "/";
            return path === "/";
        } catch (e) {
            return false;
        }
    }

    // ---------------------------------------------------------------------------
    // isHomeExpired(key)
    // True if this homepage cache entry is older than HOME_TTL_MS.
    // ---------------------------------------------------------------------------
    function isHomeExpired(key) {
        var cachedAt = homeCachedAt[key];
        if (!cachedAt) return true;
        return Date.now() - cachedAt > HOME_TTL_MS;
    }

    // ---------------------------------------------------------------------------
    // expireHomeIfNeeded(cache, key)
    // If a homepage entry is past TTL, delete it so Highway must refetch.
    // ---------------------------------------------------------------------------
    function expireHomeIfNeeded(cache, key) {
        if (!isHomeUrl(key) || !isHomeExpired(key)) return false;
        if (cache && typeof cache.delete === "function") {
            cache.delete(key);
        }
        delete homeCachedAt[key];
        return true;
    }

    // ---------------------------------------------------------------------------
    // wrapHomeCacheTtl(router)
    // Allows homepage to be cached (fast logo clicks after prefetch), but
    // cache.has / cache.get treat expired home entries as missing.
    // ---------------------------------------------------------------------------
    function wrapHomeCacheTtl(router) {
        var cache = router.cache;

        if (!cache || typeof cache.set !== "function" || cache.__ozarkeHomeBust) {
            return;
        }

        var originalSet = cache.set.bind(cache);
        var originalGet = cache.get.bind(cache);
        var originalHas = cache.has.bind(cache);
        var originalDelete = cache.delete.bind(cache);
        var originalClear = cache.clear && cache.clear.bind(cache);

        // Action: store pages normally; stamp homepage entries with a time.
        cache.set = function (key, value) {
            if (isHomeUrl(key)) {
                homeCachedAt[key] = Date.now();
            }
            return originalSet(key, value);
        };

        // Action: expired homepage => pretend it was never cached (force refetch).
        cache.get = function (key) {
            if (expireHomeIfNeeded(cache, key)) return undefined;
            return originalGet(key);
        };

        // Action: same TTL rule for has() — Highway checks has() before get().
        cache.has = function (key) {
            if (expireHomeIfNeeded(cache, key)) return false;
            return originalHas(key);
        };

        cache.delete = function (key) {
            if (isHomeUrl(key)) delete homeCachedAt[key];
            return originalDelete(key);
        };

        if (originalClear) {
            cache.clear = function () {
                homeCachedAt = {};
                return originalClear();
            };
        }

        cache.__ozarkeHomeBust = true;
    }

    // ---------------------------------------------------------------------------
    // parseMeta(html, name)
    // Reads <meta name="..."> content from a live HTML response.
    // ---------------------------------------------------------------------------
    function parseMeta(page, name) {
        var meta = page && page.querySelector('meta[name="' + name + '"]');
        return meta && meta.getAttribute("content");
    }

    function setStatus(status) {
        freshnessState.status = status;
        freshnessState.updatedAt = Date.now();
        freshnessState.failureCount = failures;
    }

    function retryBuildCheck() {
        if (retryTimer) clearTimeout(retryTimer);
        var delay = Math.min(PERIODIC_CHECK_MS, BUILD_CHECK_MIN_MS * Math.pow(2, Math.min(failures - 1, 5)));
        retryTimer = setTimeout(function () {
            retryTimer = null;
            if (document.visibilityState === "visible") checkThemeBuild();
        }, delay);
    }

    function requestReload(remoteBuild, themeId) {
        if (reloadRequested) return;
        try {
            var key = "ozarke60:last-reload:" + (themeId || "theme");
            var previous = JSON.parse(window.sessionStorage.getItem(key) || "null");
            if (previous && (previous.build === remoteBuild || Date.now() - previous.at < RELOAD_GUARD_MS)) {
                setStatus("reload-throttled");
                return;
            }
            window.sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), build: remoteBuild }));
        } catch (error) {
            setStatus("reload-guard-unavailable");
            return;
        }
        reloadRequested = true;
        freshnessState.detectedBuild = remoteBuild;
        setStatus("reloading");
        window.location.reload();
    }

    // ---------------------------------------------------------------------------
    // dropHomeFromRouterCache()
    // Deletes only homepage entries from Highway's Map (keeps other pages).
    // ---------------------------------------------------------------------------
    function dropHomeFromRouterCache() {
        var cache = window.router && window.router.cache;
        if (!cache) return;

        if (typeof cache.forEach === "function") {
            var keys = [];
            cache.forEach(function (_value, key) {
                if (isHomeUrl(key)) keys.push(key);
            });
            keys.forEach(function (key) {
                cache.delete(key);
            });
        }

        Object.keys(homeCachedAt).forEach(function (key) {
            delete homeCachedAt[key];
        });
    }

    // ---------------------------------------------------------------------------
    // clearRouterCache()
    // Empties Highway's entire in-memory page Map.
    // ---------------------------------------------------------------------------
    function clearRouterCache() {
        if (window.router && window.router.cache && typeof window.router.cache.clear === "function") {
            window.router.cache.clear();
        }
        homeCachedAt = {};
    }

    // ---------------------------------------------------------------------------
    // checkThemeBuild()
    // Fetch homepage "/" (no-store). Compare:
    //   - oz-theme-build (assets + pencil bar) vs this tab's boot hash
    //   - oz-home-build (hero slides / promo) vs this tab's home hash
    // Theme mismatch => full reload (layout shell is stale).
    // Home mismatch on "/" => reload. On other pages => drop home cache only
    // so the next logo click refetches, without yanking a PDP.
    // ---------------------------------------------------------------------------
    function checkThemeBuild() {
        var localBuild = window.__OZ_THEME_BUILD__ || parseMeta(document, "oz-theme-build");
        if (buildChecking || reloadRequested || document.visibilityState === "hidden") return;
        if (!localBuild || !/^[a-f0-9]{32}$/i.test(localBuild)) {
            failures += 1;
            setStatus("missing-local-build");
            retryBuildCheck();
            return;
        }

        var now = Date.now();
        if (now - lastBuildCheck < BUILD_CHECK_MIN_MS) return;
        lastBuildCheck = now;
        buildChecking = true;
        freshnessState.lastCheckAt = now;
        setStatus("checking");
        var themeContext = window.__OZ_THEME_CONTEXT__ || {};
        var localThemeId = String(themeContext.id || parseMeta(document, "oz-theme-id") || "");
        var localBuildScope = String(themeContext.buildScope || parseMeta(document, "oz-theme-build-scope") || "");
        var checkUrl = "/";
        if (/^\d+$/.test(localThemeId) && themeContext.role && themeContext.role !== "main") {
            checkUrl += "?preview_theme_id=" + encodeURIComponent(localThemeId);
        }
        var controller = typeof AbortController === "function" ? new AbortController() : null;
        var timeout;
        var request = Promise.resolve().then(function () {
            var options = {
                method: "GET",
                credentials: "same-origin",
                cache: "no-store",
                headers: { "X-Requested-With": "Highway" },
            };
            if (controller) options.signal = controller.signal;
            return fetch(checkUrl, options);
        }).then(function (res) {
            if (!res.ok) throw new Error("http-error");
            return res.text();
        });
        var deadline = new Promise(function (_resolve, reject) {
            timeout = setTimeout(function () {
                reject(new Error("timeout"));
                if (controller) controller.abort();
            }, BUILD_CHECK_TIMEOUT_MS);
        });

        Promise.race([request, deadline])
            .then(function (html) {
                var remotePage = new DOMParser().parseFromString(html, "text/html");
                var remoteBuild = parseMeta(remotePage, "oz-theme-build");
                var remoteHome = parseMeta(remotePage, "oz-home-build");
                var remoteThemeId = parseMeta(remotePage, "oz-theme-id");
                var remoteBuildScope = parseMeta(remotePage, "oz-theme-build-scope") || "";
                var localHome = window.__OZ_HOME_BUILD__;
                if (!remoteBuild || !/^[a-f0-9]{32}$/i.test(remoteBuild) || (localHome && (!remoteHome || !/^[a-f0-9]{32}$/i.test(remoteHome)))) {
                    throw new Error("invalid-build-metadata");
                }
                if (localThemeId && remoteThemeId !== localThemeId) {
                    throw new Error("different-theme-response");
                }
                if (remoteBuildScope !== localBuildScope) {
                    throw new Error("different-build-scope");
                }
                failures = 0;
                if (retryTimer) clearTimeout(retryTimer);
                retryTimer = null;
                setStatus("current");

                var themeMismatch = !!(remoteBuild && remoteBuild !== localBuild);
                var homeMismatch = !!(remoteHome && localHome && remoteHome !== localHome);

                if (remoteHome && !localHome) {
                    window.__OZ_HOME_BUILD__ = remoteHome;
                    dropHomeFromRouterCache();
                }

                if (!themeMismatch && !homeMismatch) {
                    try { window.sessionStorage.removeItem("ozarke60:last-reload:" + (localThemeId || "theme")); } catch (error) {}
                    return;
                }

                clearRouterCache();

                if (themeMismatch || isHomeUrl(window.location.href)) {
                    requestReload(remoteBuild, localThemeId);
                    return;
                }

                if (remoteHome) window.__OZ_HOME_BUILD__ = remoteHome;
            })
            .catch(function (error) {
                failures += 1;
                setStatus(error && error.message || "network-error");
                retryBuildCheck();
            })
            .then(function () {
                clearTimeout(timeout);
                buildChecking = false;
            });
    }

    // ---------------------------------------------------------------------------
    // scheduleBuildCheck()
    // Run build detection AFTER navigation settles so it does not slow #main-logo.
    // ---------------------------------------------------------------------------
    function scheduleBuildCheck() {
        if (buildCheckTimer) clearTimeout(buildCheckTimer);
        buildCheckTimer = setTimeout(function () {
            buildCheckTimer = null;
            checkThemeBuild();
        }, BUILD_CHECK_DELAY_MS);
    }

    // ---------------------------------------------------------------------------
    // hookRouter(router)
    // Attach TTL wrapping and deferred build checks to Highway.
    // ---------------------------------------------------------------------------
    function hookRouter(router) {
        if (!router || !router.cache || hooked) return false;

        wrapHomeCacheTtl(router);

        if (typeof router.on === "function") {
            // After SPA navigation finishes (not while Home is still loading):
            router.on("NAVIGATE_END", function () {
                scheduleBuildCheck();
            });

            // Fallback if NAVIGATE_END is unavailable in this Highway build:
            router.on("NAVIGATE_IN", function () {
                scheduleBuildCheck();
            });
        }

        hooked = true;
        return true;
    }

    // ---------------------------------------------------------------------------
    // tryHook()
    // Wait briefly for window.router (main.js is deferred).
    // ---------------------------------------------------------------------------
    function tryHook() {
        if (window.router && hookRouter(window.router)) {
            // Heal long-lived tabs even if the user never navigates (pencil bar
            // lives outside the SPA router and only updates on full reload).
            scheduleBuildCheck();
            return;
        }

        var attempts = 0;
        var id = setInterval(function () {
            attempts += 1;
            if (window.router && hookRouter(window.router)) {
                clearInterval(id);
                scheduleBuildCheck();
            } else if (attempts > 40) {
                clearInterval(id);
                // Still run build check without the router — reload path only needs
                // __OZ_THEME_BUILD__ vs live meta (pencil-bar / asset changes).
                scheduleBuildCheck();
            }
        }, 50);
    }

    // ---------------------------------------------------------------------------
    // Periodic build check
    // Idle-but-visible tabs (user reading / tab left open on screen) never fire
    // NAVIGATE_* or visibilitychange, so poll every PERIODIC_CHECK_MS. The tab
    // reloads itself when a new build (asset deploy, pencil-bar, or homepage
    // hero/slides) is detected — no user action needed. Throttle in
    // checkThemeBuild() still caps network use.
    // ---------------------------------------------------------------------------
    setInterval(function () {
        if (document.visibilityState === "visible") {
            checkThemeBuild();
        }
    }, PERIODIC_CHECK_MS);

    // ---------------------------------------------------------------------------
    // visibilitychange
    // Long-idle tabs: clear SPA cache + check for a new theme build.
    // ---------------------------------------------------------------------------
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") {
            hiddenAt = Date.now();
            return;
        }

        if (document.visibilityState !== "visible" || hiddenAt == null) return;

        var elapsed = Date.now() - hiddenAt;
        hiddenAt = null;

        // Full SPA cache flush only after a long hide (24h) — keeps nav fast.
        if (elapsed >= HIDDEN_MS) {
            clearRouterCache();
        }

        // Build check on every return to the tab (cheap; throttled to 10s).
        // Catches promo/asset changes made while the user was away.
        checkThemeBuild();
    });

    // Safari bfcache restores the whole old page; visibilitychange may not fire.
    window.addEventListener("pageshow", function (event) {
        if (event.persisted) checkThemeBuild();
    });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", tryHook);
    } else {
        tryHook();
    }
})();
